<template>
  <PageContentPage
    v-if="contentPage"
    :page="contentPage"
    :menu-item="menuItem"/>
  <PageCatalog
    v-else
    ref="catalog"
    :bestsellers="bestsellers"
    :catalog-settings="catalogSettings"
    :category-cms="categoryCms"
    :category-store="categoryStore"
    :init-catalog-scope="catalogScope"
    :init-catalog-state="catalogState"
    :init-canonical-categories="canonicalCategories"
    :init-page="page"
    :init-per-page="perPage"
    :init-products="products"
    :menu-item="menuItem"
    :virtual-category-cms="virtualCategoryCms"/>
</template>

<script>
import Component from '~/sites/shop/pages/_'
import PageCatalogConfigurable from '@theme/components/product/PageCatalogConfigurable'

export default {
  components: { PageCatalogConfigurable },
  extends: Component,
  async asyncData(context) {
    const result = await Component.asyncData(context)
    await context.app.apolloProvider.defaultClient.cache.reset()
    return {
      configurableCategory: result.categoryCms?.product_configurable,
      ...result,
    }
  },
}
</script>
